import { validObjectId } from '@/utils/algolia';
import { transformSiteVariable } from '~/plugins/0.craftClient';
import InstantSearch from 'vue-instantsearch/vue3/es';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(InstantSearch);

  const fetchSingleAlgoliaObject = async function (objectID, indexName) {
    if (!validObjectId(objectID)) throw new TypeError('argument is not a valid algolia objectId');

    const { algoliaApplicationId, algoliaSearchApiKey } = nuxtApp.$config.public;
    const url = `https://${algoliaApplicationId}-dsn.algolia.net/1/indexes/${indexName}/${objectID}?attributesToRetrieve=*`;

    const response = await fetch(url, {
      headers: {
        'X-Algolia-API-Key': algoliaSearchApiKey,
        'X-Algolia-Application-Id': algoliaApplicationId,
      },
    });

    if (!response.ok) {
      throw new Error(
        `${indexName} msg: ${response?.statusText}, algoliaApplicationId: ${algoliaApplicationId}, index: ${indexName}, objectId: ${objectID}`
      );
    }

    return response.json();
  };

  const fetchMultipleAlgoliaObjects = async function (objectIds, indexName) {
    const { algoliaApplicationId, algoliaSearchApiKey } = nuxtApp.$config.public;

    const url = `https://${algoliaApplicationId}-dsn.algolia.net/1/indexes/*/objects`;

    const response = await fetch(url, {
      method: 'POST',
      body: JSON.stringify({
        requests: objectIds.map((objectID) => ({
          indexName,
          objectID,
          attributesToRetrieve: '*',
        })),
      }),
      headers: {
        'X-Algolia-API-Key': algoliaSearchApiKey,
        'X-Algolia-Application-Id': algoliaApplicationId,
      },
    });

    if (!response.ok) {
      throw new Error(
        `${indexName} msg: ${response?.statusText}, algoliaApplicationId: ${algoliaApplicationId}, index: ${indexName}`
      );
    }

    return response.json();
  };

  const fetchExercises = (objectIds) => {
    const locale = transformSiteVariable({ site: nuxtApp.$i18n.locale.value }).site;

    return fetchMultipleAlgoliaObjects(objectIds, `feg_exercise_${locale}`);
  };

  const fetchExerciseById = (objectID) => {
    const locale = transformSiteVariable({ site: nuxtApp.$i18n.locale.value }).site;

    return fetchSingleAlgoliaObject(objectID, `feg_exercise_${locale}`);
  };

  const fetchRoutineById = (objectID) => {
    const locale = transformSiteVariable({ site: nuxtApp.$i18n.locale.value }).site;

    return fetchSingleAlgoliaObject(objectID, `routine_${locale}`);
  };

  const fetchFegWorkoutById = (objectID) => {
    const locale = transformSiteVariable({ site: nuxtApp.$i18n.locale.value }).site;

    return fetchSingleAlgoliaObject(objectID, `feg_workout_${locale}`);
  };

  const fetchCourseById = (objectID) => {
    const locale = transformSiteVariable({ site: nuxtApp.$i18n.locale.value }).site;

    return fetchSingleAlgoliaObject(objectID, `course_contents_learnworlds_${locale}`);
  };

  return {
    provide: {
      algoliaWorkouts: {
        fetchExercises,
        fetchExerciseById,
        fetchRoutineById,
        fetchFegWorkoutById,
        fetchCourseById,
      },
    },
  };
});
